export default "__VITE_ASSET__D$fjYkic__"